<template>
  <div class="global-content-flex">
    <!-- 切换导航栏 -->
    <el-tabs v-model="topSelect" @tab-click="hugItemBtn">
      <el-tab-pane
        label="积分变更明细"
        name="1"
        v-if="checkPermission('会员信息管理', '积分变更记录')"
      ></el-tab-pane>
      <el-tab-pane
        label="等级变更明细"
        name="2"
        v-if="checkPermission('会员信息管理', '等级变更记录')"
      ></el-tab-pane>
      <el-tab-pane
        label="成长值变更明细"
        name="3"
        v-if="checkPermission('会员信息管理', '成长值变更记录')"
      ></el-tab-pane>
    </el-tabs>
    <!-- 顶部搜索区域 -->
    <div
      class="activityWrapper"
      v-if="topSelect == 1 && checkPermission('会员信息管理', '积分变更记录')"
    >
      <y-form
        ref="pointFormRef"
        :form-info="pointFormInfo"
        @search="hugItemSearch"
        @selfReset="reset"
      >
        <template #platform>
          <y-shop-by-platform
            ref="yShopByPlatformRef"
            :shopData="shopData"
            @change="shopChange"
          ></y-shop-by-platform>
        </template>
      </y-form>
    </div>
    <div
      class="activityWrapper"
      v-if="topSelect == '2' && checkPermission('会员信息管理', '等级变更记录')"
    >
      <y-form
        ref="levelFormRef"
        :form-info="levelFormInfo"
        @search="hugItemSearch"
      >
      </y-form>
    </div>
    <div
      class="activityWrapper"
      v-if="topSelect == 3 && checkPermission('会员信息管理', '成长值变更记录')"
    >
      <y-form
        ref="growFormRef"
        :form-info="growFormInfo"
        @search="hugItemSearch"
        @selfReset="reset"
      >
        <template #platform>
          <y-shop-by-platform
            ref="yShopByPlatformRef"
            :shopData="shopData"
            @change="shopChange"
          ></y-shop-by-platform>
        </template>
      </y-form>
    </div>
    <!-- 表格 - 积分变更明细 -->
    <div
      class="global-felx-1"
      v-if="topSelect == 1 && checkPermission('会员信息管理', '积分变更记录')"
    >
      <y-table
        :tableData="tableData"
        :tableInfo="pointTableInfo"
        tooltip-effect="dark"
        :loading="talbeLoading"
        :pageInfo="{
          pageNum: formDataList.pageNum,
          pageSize: formDataList.pageSize,
          total: totalList,
        }"
        :autoMaxHeight="false"
        @handlePage="handlePage"
      >
        <template #platform="scope">
          <span> {{ $getPlatformNameByValue(scope.row.platform) }} </span>
        </template>
      </y-table>
    </div>
    <!-- 表格 - 等级变更明细 -->
    <div
      class="global-felx-1"
      v-if="topSelect == 2 && checkPermission('会员信息管理', '等级变更记录')"
    >
      <y-table
        :tableData="tableData"
        :tableInfo="levelTableInfo"
        tooltip-effect="dark"
        :loading="talbeLoading"
        :pageInfo="{
          pageNum: formDataList.pageNum,
          pageSize: formDataList.pageSize,
          total: totalList,
        }"
        :autoMaxHeight="false"
        @handlePage="handlePage"
      >
      </y-table>
    </div>
    <!-- 表格 - 成长值变更明细 -->
    <div
      class="global-felx-1"
      v-if="topSelect == 3 && checkPermission('会员信息管理', '成长值变更记录')"
    >
      <y-table
        :tableData="tableData"
        :tableInfo="growTableInfo"
        tooltip-effect="dark"
        :loading="talbeLoading"
        :pageInfo="{
          pageNum: formDataList.pageNum,
          pageSize: formDataList.pageSize,
          total: totalList,
        }"
        :autoMaxHeight="false"
        @handlePage="handlePage"
      >
        <template #platform="scope">
          <span> {{ $getPlatformNameByValue(scope.row.platform) }} </span>
        </template>
      </y-table>
    </div>
  </div>
</template>

<script>
import {
  getUpdateRecordPage,
  getScoreGradeUpdateRecord,
  getGrowValueChangeRecord,
} from "@/api/memberMessageSystem";
export default {
  components: {},
  props: {
    memberId: {
      type: String,
    },
    shopData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      topSelect: "1",
      formDataList: {
        memberId: this.memberId,
        changeSource: "",
        startScores: "",
        endScores: "",
        // scoresCardId:'',
        startUpdateTime: "",
        pageNum: 1,
        pageSize: 10,
        scoresType: "",
        endUpdateTime: "",

        changeType: "",
        startTime: "",
        endTime: "",

        channelSellerId: "",
        updateType: "",
        changeValStart: "",
        changeValEnd: "",
        changeTimeStart: "",
        changeTimeEnd: "",
        orderId: null,
      },
      searchForm: {
        platform: "",
        sellerManageId: "",
      },
      //范围选择
      rangelList: [
        {
          value: 1,
          label: "介于(含边界)",
        },
        {
          value: 2,
          label: "大于",
        },
        {
          value: 3,
          label: "大于等于",
        },
        {
          value: 4,
          label: "小于",
        },
        {
          value: 5,
          label: "小于等于",
        },
        {
          value: 6,
          label: "等于",
        },
        {
          value: 7,
          label: "不等于",
        },
      ],
      changeTypeList: [
        {
          value: "",
          label: "不限",
        },
        {
          value: 1,
          label: "会员营销",
        },
        {
          value: 2,
          label: "互动活动",
        },
        {
          value: 3,
          label: "手工调整",
        },
        {
          value: 4,
          label: "积分过期",
        },
        {
          value: 5,
          label: "积分导入",
        },
        {
          value: 6,
          label: "订单赠送",
        },
        {
          value: 7,
          label: "退单扣减",
        },
        {
          value: 8,
          label: "其他积分来源",
        },
      ],
      // 1升级 2保级 3降级
      changeTypeList2: [
        {
          value: "",
          label: "不限",
        },
        {
          value: 1,
          label: "升级",
        },
        {
          value: 2,
          label: "保级",
        },
        {
          value: 3,
          label: "降级",
        },
      ],
      // 变更来源 0手工调整 1成长值过期 2订单赠送 3退单扣减
      changeTypeList3: [
        {
          value: "",
          label: "不限",
        },
        {
          value: 0,
          label: "手工调整",
        },
        {
          value: 1,
          label: "成长值过期",
        },
        {
          value: 2,
          label: "订单赠送",
        },
        {
          value: 3,
          label: "退单扣减",
        },
      ],
      // 变更来源 1手动导入会员 2 会员正常升级 3会员等级失效降级 4会员等级失效保级 5手动调整
      changeTypeList4: [
        {
          value: "",
          label: "不限",
        },
        {
          value: 1,
          label: "手动导入会员",
        },
        {
          value: 2,
          label: "会员正常升级",
        },
        {
          value: 3,
          label: "会员等级失效降级",
        },
        {
          value: 4,
          label: "会员等级失效保级",
        },
        {
          value: 5,
          label: "手动调整",
        },
      ],
      scoresTypeList: [
        {
          value: "",
          label: "不限",
        },
        {
          value: 0,
          label: "发放",
        },
        {
          value: 1,
          label: "消费",
        },
        {
          value: 2,
          label: "过期",
        },
        {
          value: 3,
          label: "作废",
        },
      ],
      scoresTypeList2: [
        {
          value: "",
          label: "不限",
        },
        {
          value: 0,
          label: "发放",
        },
        {
          value: 1,
          label: "过期",
        },
        {
          value: 2,
          label: "作废",
        },
      ],
      talbeLoading: false,
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.formDataList.endTime) {
            return (
              time.getTime() > new Date(this.formDataList.endTime).getTime()
            );
          } else {
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.formDataList.startTime) {
            return (
              time.getTime() < new Date(this.formDataList.startTime).getTime()
            );
          } else {
          }
        },
      },
      totalList: 0,
      tableData: [],
      MemberSystemInfo: "",

      pointFormInfo: [
        {
          prop: "platform",
          label: "平台名称：",
          slot: "platform",
        },
        {
          label: "变更类型：",
          prop: "scoresType",
          type: "Select",
          value: "",
          options: [
            {
              value: "",
              label: "不限",
            },
            {
              value: 0,
              label: "发放",
            },
            {
              value: 1,
              label: "消费",
            },
            {
              value: 2,
              label: "过期",
            },
            {
              value: 3,
              label: "作废",
            },
          ],
        },
        {
          label: "变更来源：",
          prop: "changeSource",
          type: "Select",
          value: "",
          options: [
            {
              value: "",
              label: "不限",
            },
            {
              value: 1,
              label: "会员营销",
            },
            {
              value: 2,
              label: "互动活动",
            },
            {
              value: 3,
              label: "手工调整",
            },
            {
              value: 4,
              label: "积分过期",
            },
            {
              value: 5,
              label: "积分导入",
            },
            {
              value: 6,
              label: "订单赠送",
            },
            {
              value: 7,
              label: "退单扣减",
            },
            {
              value: 8,
              label: "其他积分来源",
            },
          ],
        },
        {
          label: "订单ID：",
          prop: "orderId",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "积分变更值：",
          startKey: "startScores",
          endKey: "endScores",
          type: "InputDouble",
          startPlaceholder: "请输入",
          endPlaceholder: "请输入",
        },
        {
          label: "变更时间：",
          prop: "time",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startUpdateTime",
          endKey: "endUpdateTime",
        },
      ],
      levelFormInfo: [
        {
          label: "变更类型：",
          prop: "changeType",
          type: "Select",
          value: "",
          options: [
            {
              value: "",
              label: "不限",
            },
            {
              value: 1,
              label: "升级",
            },
            {
              value: 2,
              label: "保级",
            },
            {
              value: 3,
              label: "降级",
            },
          ],
        },
        {
          label: "变更来源：",
          prop: "changeSource",
          type: "Select",
          value: "",
          options: [
            {
              value: "",
              label: "不限",
            },
            {
              value: 1,
              label: "手动导入会员",
            },
            {
              value: 2,
              label: "会员正常升级",
            },
            {
              value: 3,
              label: "会员等级失效降级",
            },
            {
              value: 4,
              label: "会员等级失效保级",
            },
            {
              value: 5,
              label: "手动调整",
            },
          ],
        },
        {
          label: "变更时间：",
          prop: "time",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
        },
      ],
      growFormInfo: [
        {
          prop: "platform",
          label: "平台名称：",
          slot: "platform",
        },
        {
          label: "变更类型：",
          prop: "updateType",
          type: "Select",
          value: "",
          options: [
            {
              value: "",
              label: "不限",
            },
            {
              value: 0,
              label: "发放",
            },
            {
              value: 1,
              label: "过期",
            },
            {
              value: 2,
              label: "作废",
            },
          ],
        },
        {
          label: "变更来源：",
          prop: "changeSource",
          type: "Select",
          value: "",
          options: [
            {
              value: "",
              label: "不限",
            },
            {
              value: 0,
              label: "手工调整",
            },
            {
              value: 1,
              label: "成长值过期",
            },
            {
              value: 2,
              label: "订单赠送",
            },
            {
              value: 3,
              label: "退单扣减",
            },
          ],
        },
        {
          label: "成长变更值：",
          startKey: "changeValStart",
          endKey: "changeValEnd",
          type: "InputDouble",
          startPlaceholder: "请输入",
          endPlaceholder: "请输入",
        },
        {
          label: "变更时间：",
          prop: "time",
          type: "DateRange",
          dateType: "datetime",
          startKey: "changeTimeStart",
          endKey: "changeTimeEnd",
        },
      ],
      pointTableInfo: [
        {
          prop: "platform",
          label: "平台",
          slot: "platform",
        },
        {
          prop: "sellerManageName",
          label: "店铺名称",
        },
        {
          prop: "orderId",
          label: "订单ID",
          showOverflowTooltip: true,
        },
        {
          prop: "scoresCount",
          label: "积分变更值",
          align: "right",
        },
        {
          prop: "scoresType",
          label: "变更类型",
          formatter: (row) => {
            if (row.scoresType == 0) {
              return "发放";
            } else if (row.scoresType == 1) {
              return "消费";
            } else if (row.scoresType == 2) {
              return "过期";
            } else if (row.scoresType == 3) {
              return "作废";
            } else {
              return "-";
            }
          },
        },
        {
          prop: "changeSource",
          label: "变更来源",
          formatter: (row) => {
            if (row.changeSource == 1) {
              return "会员营销";
            } else if (row.changeSource == 2) {
              return "互动活动";
            } else if (row.changeSource == 3) {
              return "手工调整";
            } else if (row.changeSource == 4) {
              return "积分过期";
            } else if (row.changeSource == 5) {
              return "积分导入";
            } else if (row.changeSource == 6) {
              return "订单赠送";
            } else if (row.changeSource == 7) {
              return "退单扣减";
            } else if (row.changeSource == 8) {
              return "其他";
            } else {
              return "-";
            }
          },
        },
        {
          prop: "expiryDate",
          label: "过期时间",
        },
        {
          prop: "remark",
          label: "备注",
          showOverflowTooltip: true,
        },
        {
          prop: "createTime",
          label: "变更时间",
        },
        {
          prop: "currentScores",
          label: "变更后积分",
          type: "tips",
          tipsContent:
            "仅为当前流水变动后的瞬时可用积分，最终可用积分请以会员详情为准。",
          isTipsSlot: true,
          tooltipScale: true,
          align: "right",
        },
      ],
      levelTableInfo: [
        {
          prop: "changeSource",
          label: "变更来源",
          formatter: (row) => {
            if (row.changeSource == 1) {
              return "手动导入会员";
            } else if (row.changeSource == 2) {
              return "会员正常升级";
            } else if (row.changeSource == 3) {
              return "会员等级失效降级";
            } else if (row.changeSource == 4) {
              return "会员等级失效保级";
            } else if (row.changeSource == 5) {
              return "手动调整";
            } else {
              return "-";
            }
          },
        },
        {
          prop: "changeBeforeGrade",
          label: "变更前等级",
          align: "right",
        },
        {
          prop: "changeAfterGrade",
          label: "变更后等级",
          align: "right",
        },
        {
          prop: "changeType",
          label: "变更类型",
          formatter: (row) => {
            if (row.changeType == 1) {
              return "升级";
            } else if (row.changeType == 2) {
              return "保级";
            } else if (row.changeType == 3) {
              return "降级";
            } else {
              return "-";
            }
          },
        },
        {
          prop: "expiryDate",
          label: "等级有效时间",
        },
        {
          prop: "remark",
          label: "备注",
          showOverflowTooltip: true,
        },
        {
          prop: "createTime",
          label: "变更时间",
        },
      ],
      growTableInfo: [
        {
          prop: "platform",
          label: "平台",
          slot: "platform",
        },
        {
          prop: "sellerManageName",
          label: "店铺名称",
        },
        {
          prop: "scoresGrowRecordId",
          label: "变更流水号",
          showOverflowTooltip: true,
        },
        {
          prop: "scoresCount",
          label: "变更值",
          align: "right",
        },
        {
          prop: "scoresType",
          label: "变更类型",
          formatter: (row) => {
            if (row.scoresType == 0) {
              return "发放";
            } else if (row.scoresType == 1) {
              return "作废";
            } else if (row.scoresType == 2) {
              return "过期";
            } else {
              return "-";
            }
          },
        },
        {
          prop: "expiryDate",
          label: "成长值到期时间",
        },
        {
          prop: "changeSource",
          label: "变更来源",
          formatter: (row) => {
            if (row.changeSource == 0) {
              return "手工调整";
            } else if (row.changeSource == 1) {
              return "成长值过期";
            } else if (row.changeSource == 2) {
              return "订单赠送";
            } else if (row.changeSource == 3) {
              return "退单扣减";
            } else {
              return "-";
            }
          },
        },
        {
          prop: "remark",
          label: "备注",
          showOverflowTooltip: true,
        },
        {
          prop: "createTime",
          label: "变更时间",
        },
        {
          prop: "remainCount",
          label: "变更后成长值",
          align: "right",
        },
      ],
    };
  },
  created() {
    // 获取当前会员体系详情
    this.MemberSystemInfo = this.$store.state.MemberSystemInfo;
    console.log("this.MemberSystemInfo", this.MemberSystemInfo);
  },
  mounted() {
    this.getUpdateRecordPage();
    this.formDataList.scoresCardId = this.MemberSystemInfo.scoresCardId;
    this.formDataList.channelSellerId = this.MemberSystemInfo.channelSellerId;
    if (this.checkPermission("会员信息管理", "积分变更记录")) {
      this.topSelect = "1";
    } else if (this.checkPermission("会员信息管理", "等级变更记录")) {
      this.topSelect = "2";
    } else if (this.checkPermission("会员信息管理", "成长值变更记录")) {
      this.topSelect = "3";
    }
    // this.hugItemBtn();
  },
  methods: {
    shopChange(platform, shop) {
      this.searchForm.platform = platform;
      this.searchForm.sellerManageId = shop;
    },
    // 获取活动列表
    getUpdateRecordPage() {
      this.talbeLoading = true;
      const query = {
        ...this.formDataList,
        platform: this.searchForm.platform,
        sellerManageId: this.searchForm.sellerManageId,
      };
      getUpdateRecordPage(query).then((res) => {
        this.talbeLoading = false;
        if (res.code == 200) {
          this.tableData = res.data.dataList;
          this.totalList = res.data.pageInfo.total;
        }
      });
    },
    getScoreGradeUpdateRecord() {
      this.talbeLoading = true;
      getScoreGradeUpdateRecord(this.formDataList).then((res) => {
        this.talbeLoading = false;
        if (res.code == 200) {
          this.tableData = res.data.dataList;
          this.totalList = res.data.pageInfo.total;
        }
      });
    },
    getGrowValueChangeRecord() {
      this.talbeLoading = true;
      console.log("this.formDataList", this.formDataList);
      const query = {
        ...this.formDataList,
        platform: this.searchForm.platform,
        sellerManageId: this.searchForm.sellerManageId,
      };
      getGrowValueChangeRecord(query).then((res) => {
        this.talbeLoading = false;
        if (res.code == 200) {
          this.tableData = res.data.dataList;
          this.totalList = res.data.pageInfo.total;
        }
      });
    },
    getClean() {
      this.formDataList = {
        memberId: this.memberId,
        changeSource: "",
        startScores: "",
        endScores: "",
        scoresCardId: this.MemberSystemInfo.scoresCardId,
        startUpdateTime: "",
        pageNum: 1,
        pageSize: 10,
        scoresType: "",
        endUpdateTime: "",

        changeType: "",
        startTime: "",
        endTime: "",

        channelSellerId: "",
        updateType: "",
        changeValStart: "",
        changeValEnd: "",
        changeTimeStart: "",
        changeTimeEnd: "",
      };
      this.hugItemBtn();
    },
    handlePage(page) {
      this.formDataList.pageNum = page.pageNum;
      this.formDataList.pageSize = page.pageSize;
      // this.hugItemBtn();
      this.searchMethod();
    },
    handleSizeChange(val) {
      this.formDataList.pageSize = val;
      this.hugItemBtn();
    },
    handleCurrentChange(val) {
      this.formDataList.pageNum = val;
      this.hugItemBtn();
    },
    // 菜单判断
    checkPermission(fatherName, name = null) {
      let isHave = false;
      let fatherList = this.$store.getters.fistMenuList;
      let childrenList = this.$store.getters.childMenuList;
      let fatherIndex = fatherList.findIndex(
        (item) => item.name === "忠诚度管理"
      );
      let childrenData = childrenList[fatherIndex] || [];
      let childrenIndex = childrenData.findIndex(
        (item) => item.name === fatherName
      );
      // console.log("childrenIndex", childrenIndex);
      if (name) {
        let menuData = childrenData[childrenIndex] || { children: [] };
        menuData.children.forEach((item) => {
          if (item.name === name) {
            isHave = true;
          }
        });
      } else {
        if (childrenIndex != -1) isHave = true;
      }
      return isHave;
    },
    //点击切换
    hugItemBtn() {
      this.formDataList.pageNum = 1;
      this.searchForm.platform = "";
      this.searchForm.sellerManageId = "";
      this.$nextTick(() => {
        if (this.topSelect == "1") {
          this.$refs.pointFormRef.handleReset();
        } else if (this.topSelect == "2") {
          this.$refs.levelFormRef.handleReset();
        } else if (this.topSelect == "3") {
          this.$refs.growFormRef.handleReset();
        }
      });
    },
    hugItemSearch(obj) {
      for (const key in obj) {
        if (key != "platform") {
          this.formDataList[key] = obj[key];
        }
      }
      this.formDataList.pageNum = 1;
      // this.hugItemBtn();
      this.searchMethod();
    },
    reset() {
      this.$refs.yShopByPlatformRef.reset();
    },
    searchMethod() {
      if (this.topSelect == "2") {
        this.getScoreGradeUpdateRecord();
      } else if (this.topSelect == "3") {
        this.getGrowValueChangeRecord();
      } else if (this.topSelect == "1") {
        this.getUpdateRecordPage();
      }
    },
    //时间选择器
    clearTimeSendTime1() {
      this.formDataList.endUpdateTime = "";
      this.formDataList.startUpdateTime = "";
    },
    clearTimeSendTime2() {
      this.formDataList.changeTimeEnd = "";
      this.formDataList.changeTimeStart = "";
    },
    clearTimeSendTime3() {
      this.formDataList.startTime = "";
      this.formDataList.endTime = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.displayItem {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.space_between {
  display: flex;
  justify-content: space-between;
  width: 150px;
  align-items: center;
}
.activityWrapper {
  box-sizing: border-box;
  margin: 0px 0 16px 0;
}
</style>
